import { DATABASE } from "../../../../database";
import { DataBaseEnum } from "../../../../database/enum";
import { INTERNAL_API_V2_GET } from "../../base";

export async function API_V2_AUTHENTICATED() {
    const url = 'auth';

    const dataBase = DataBaseEnum.USER_AUTHENTICATED;
    const localBD = new DATABASE(dataBase.name)
    const bdItem = await localBD.getItemById(url);

    let response = null;
    if (!bdItem) {
        response = (await INTERNAL_API_V2_GET('auth'))?.status;
        try { await localBD.insert(url, response) } catch (error) { }
    } else response = bdItem.content;
    return response;
}
